export default {
   id: 2,
   corporate_name: "Fintask",
   logo:
      "https://s3.amazonaws.com/api.static.testing.fintask/organization/logo/2020/09/23/fintask_white.ico",
   primary_color: "3aa9ff",
   secondary_color: "ffffff",
   slug: "fintask"
};
